export default __webpack_public_path__ + "static/media/001-balloon-green.a9924256.svg";